import Empty from 'constants/empty';
import LanguageLocale from 'utils/LanguageLocale';
import { isChangeQuantityEnabled } from 'utils/arChangeQuantityFlag';

/**
 * Returns true if a feature flag is enabled globally and for the given country.
 */
const isFeatureEnabled = (flagConfig = {}, country) => !!(flagConfig.isEnabled && flagConfig[`isEnabled${country}`]);

/**
 * Returns resolved feature flags for AutoReplenishment from Sephora configuration.
 * Reads Sephora.configurationSettings once — safe to call outside React lifecycle.
 */
export const getFeatureFlags = () => {
    const config = Sephora.configurationSettings || Empty.Object;
    const arConfig = config.autoReplenishmentConfigurations || Empty.Object;
    const country = LanguageLocale.getCurrentCountry();

    const isChangeAddressEnabled = !!(
        arConfig.enableReplenishmentAddressModifiable && arConfig[`enableReplenishmentAddressModifiable_${country}`]?.isEnabled
    );

    return {
        isAddressCVVCheckEnabled: !!arConfig?.addressUpdateCVVCheck?.isEnabled,
        isAutoReplenishEmptyHubEnabled: !!config.isAutoReplenishEmptyHubEnabled,
        isChangeAddressEnabled: isChangeAddressEnabled,
        isChangeDateEnabled: isFeatureEnabled(arConfig.changeDate, country),
        isChasePaymentEnabled: !!config.isChasePaymentEnabled,
        isChangeFrequencyEnabled: !!arConfig.enableReplenishmentFrequencyModifiable,
        isChangePaymentEnabled: !!arConfig.enableReplenishmentPaymentModifiable,
        isChangeQuantityEnabled: isChangeQuantityEnabled(),
        isFlexIncentivesEnabled: isFeatureEnabled(arConfig.flexIncentives, country),
        isNewManageDesignEnabled: !!arConfig?.changeDate?.newDesign?.isEnabled,
        isNewResumeDesignEnabled: isFeatureEnabled(arConfig.resume?.enhancedDesign, country),
        isOrderNowEnabled: isFeatureEnabled(arConfig.getItNow, country),
        isSkipPauseEnabled: !!arConfig.enableReplenishmentOperations,
        isSkuSwapEnabled: isFeatureEnabled(arConfig.skuSwap, country)
    };
};
